import React, { useState } from 'react';
import { C } from '../tokens.js';
import { Btn } from '../components/ui.jsx';

export const OnboardingScreen = ({onDone}) => {
  const [idx,setIdx]=useState(0);
  const slides=[
    { em:'🛵', bg:['#f1fbfd','#d4f1f7'], tag:'Daily Essentials',
      title:'Fresh deliveries before you wake up',
      body:'Subscribe to milk, bread, eggs and more from local vendors — delivered daily, weekly or on your schedule.',
      bullets:['Set once, delivered forever','Pause or skip any day','Multiple vendors in one order'] },
    { em:'📍', bg:['#f0fdf4','#dcfce7'], tag:'Discover Nearby',
      title:'Grocers and salons close to home',
      body:'Find grocery suppliers and salon branches serving your neighbourhood, sorted by distance and availability.',
      bullets:['Local grocery and dairy stores','Verified salon branches','Filter by rating, distance, open now'] },
    { em:'🪑', bg:['#eff6ff','#dbeafe'], tag:'Instant Booking',
      title:'Book salon slots in seconds',
      body:'Reserve salon services, pay the advance, and see the refund window clearly before you confirm.',
      bullets:['Real-time salon slots','Advance and refund policy shown upfront','Manage bookings from one place'] },
  ];
  const s=slides[idx]; const isLast=idx===slides.length-1;
  return (
    <div className="fade-in" style={{flex:1,display:'flex',flexDirection:'column',background:C.bg}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 22px 0'}}>
        <img src="/grabioz-logo.png" alt="grabioz" style={{height:30,width:'auto',display:'block'}}/>
        <button onClick={onDone} style={{background:'none',border:'none',color:C.textMed,fontSize:13,fontWeight:600,cursor:'pointer',padding:'6px 10px'}}>Skip</button>
      </div>
      <div style={{margin:'18px 24px 0',borderRadius:28,background:`linear-gradient(135deg,${s.bg[0]},${s.bg[1]})`,height:220,display:'flex',alignItems:'center',justifyContent:'center',fontSize:100,flexShrink:0,position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',inset:0,opacity:.08,background:`radial-gradient(circle at 70% 30%,${C.primary},transparent 60%)`}}/>
        <span style={{filter:'drop-shadow(0 8px 24px rgba(0,0,0,.12))'}}>{s.em}</span>
        <div style={{position:'absolute',top:14,left:14,padding:'5px 12px',background:'rgba(255,255,255,.8)',borderRadius:100,fontSize:11,fontWeight:700,color:C.primary}}>{s.tag}</div>
      </div>
      <div style={{flex:1,padding:'24px 28px 0',display:'flex',flexDirection:'column',gap:14}}>
        <h2 style={{fontSize:24,fontWeight:800,color:C.text,lineHeight:1.25}}>{s.title}</h2>
        <p style={{fontSize:14,color:C.textMed,lineHeight:1.65}}>{s.body}</p>
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {s.bullets.map((b,i)=>(
            <div key={i} style={{display:'flex',alignItems:'center',gap:10}}>
              <div style={{width:20,height:20,borderRadius:10,background:'#e6f7fb',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5L8.5 2" stroke={C.primary} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </div>
              <span style={{fontSize:13,fontWeight:600,color:C.text}}>{b}</span>
            </div>
          ))}
        </div>
      </div>
      <div style={{padding:'20px 24px 36px',display:'flex',flexDirection:'column',gap:14}}>
        <div style={{display:'flex',justifyContent:'center',gap:6}}>
          {slides.map((_,i)=>(
            <button key={i} onClick={()=>setIdx(i)} style={{width:i===idx?24:7,height:7,borderRadius:4,background:i===idx?C.primary:C.primaryLight,border:'none',cursor:'pointer',transition:'all .25s',padding:0}}/>
          ))}
        </div>
        {isLast?(
          <div style={{display:'flex',flexDirection:'column',gap:10}}>
            <Btn full onClick={onDone}>Get started →</Btn>
            <p style={{fontSize:12,color:C.textMed,textAlign:'center'}}>Already have an account? <button onClick={onDone} style={{background:'none',border:'none',color:C.primary,fontWeight:700,cursor:'pointer',fontSize:12}}>Sign in</button></p>
          </div>
        ):(
          <Btn full onClick={()=>setIdx(i=>i+1)}>Next</Btn>
        )}
      </div>
    </div>
  );
};
